import './TableSectionsExpertMode.styles.scss';

import { observer } from 'mobx-react';
import { FC, useMemo, useState } from 'react';

import { Permission } from '../../../model/enumeration/Permission.enum';
import authStore from '../../../store/AuthStore';
import permissionStore from '../../../store/PermissionStore';
import tableStore from '../../../store/TableStore';
import ChatHistoryExpertMode from './ChatHistoryExpertMode/ChatHistoryExpertMode';
import EventLogsExpertMode from './EventLogsExpertMode/EventLogsExpertMode';
import LobbyTablesExpertMode from './LobbyTablesExpertMode/LobbyTablesExpertMode';

const TableSectionsExpertMode: FC = () => {
  const selectedTableId = tableStore.viewingTableIds[0];
  const isSingleTableSelected = tableStore.viewingTableIds.length === 1;

  const [isOpenEventLogs, setIsOpenEventLogs] = useState(true);
  const [isOpenChat, setIsOpenChat] = useState(false);
  const [isOpenLobbyTables, setIsOpenLobbyTables] = useState(false);

  const hasManageBotSeatingPermission = useMemo(
    () => permissionStore.hasPermission(Permission.MANAGE_BOTS_SEATING),
    [authStore.authenticatedUser],
  );

  const toggleSections = (
    eventLogs = true,
    chat = false,
    lobby = false,
  ): void => {
    setIsOpenEventLogs(eventLogs);
    setIsOpenChat(chat);
    setIsOpenLobbyTables(lobby);
  };

  return (
    <div className="TableSectionsExpertMode-Component">
      <div className="game-events-header">
        <div
          className={`title cursor-pointer${isOpenEventLogs ? ' active' : ''}`}
          onClick={() => toggleSections(true, false, false)}
        >
          Actions
        </div>
        <div
          className={`title cursor-pointer${isOpenChat ? ' active' : ''}`}
          id={`chat-expert-mode-btn-${selectedTableId}`}
          onClick={() => toggleSections(false, true, false)}
        >
          Chat
        </div>
        {hasManageBotSeatingPermission && (
          <div
            className={`title cursor-pointer${
              isOpenLobbyTables ? ' active' : ''
            }`}
            id={`lobby-table-expert-mode-btn-${selectedTableId}`}
            onClick={() => toggleSections(false, false, true)}
          >
            Lobby
          </div>
        )}
      </div>
      {isOpenEventLogs && isSingleTableSelected && selectedTableId && (
        <EventLogsExpertMode tableId={selectedTableId} />
      )}
      {isOpenChat && isSingleTableSelected && selectedTableId && (
        <ChatHistoryExpertMode tableId={selectedTableId} />
      )}
      {isOpenLobbyTables && isSingleTableSelected && selectedTableId && (
        <LobbyTablesExpertMode
          tableId={selectedTableId}
          key={selectedTableId}
        />
      )}
    </div>
  );
};

export default observer(TableSectionsExpertMode);
